import styled from 'styled-components';
import {
  CommercialAreaData,
  ExtractionAreaData,
  FilterType,
  GreenAreaData,
  IndustrialAreaData,
  ManagementAreaData,
  ResidentialAreaData,
  UseDistrictData,
  UseAreaData,
} from '../FilterData';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import {
  ApplyButton,
  Bottom,
  ButtonBox,
  ResetButton,
  SelectedChip,
  SelectedChipBox,
} from './OptionModal.styles';

interface Props {
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

const TabData = ['도시지역', '관리지역', '기타지역', '용도지구', '용도구역'];

const groupedUrbanAreaData = [
  { title: '주거지역', data: ResidentialAreaData },
  { title: '상업지역', data: CommercialAreaData },
  { title: '공업지역', data: IndustrialAreaData },
  { title: '녹지지역', data: GreenAreaData },
];

function UseAreaOption({ onClose, filters, setFilters }: Props) {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState('도시지역');
  const [selectedItems, setSelectedItems] = useState<string[]>(filters.useArea);

  const toggleItem = (value: string) => {
    setSelectedItems((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  const renderOptionList = () => {
    switch (selectedTab) {
      case '도시지역':
        return (
          <>
            {groupedUrbanAreaData.map(({ title, data }) => {
              const allSelected = data.every((item) =>
                selectedItems.includes(item.name),
              );

              return (
                <OptionList key={title}>
                  <OptionTitle>{title}</OptionTitle>
                  <Option
                    onClick={() => {
                      if (allSelected) {
                        setSelectedItems((prev) =>
                          prev.filter(
                            (item) => !data.map((d) => d.name).includes(item),
                          ),
                        );
                      } else {
                        setSelectedItems((prev) =>
                          Array.from(
                            new Set([...prev, ...data.map((d) => d.name)]),
                          ),
                        );
                      }
                    }}
                  >
                    <img
                      src={`/assets/images/check/${
                        allSelected ? 'check-blue-on' : 'check-blue-off'
                      }.svg`}
                      alt=""
                    />
                    {title} 전체
                  </Option>

                  {data.map(({ name }) => (
                    <Option key={name} onClick={() => toggleItem(name)}>
                      <img
                        src={`/assets/images/check/${
                          selectedItems.includes(name)
                            ? 'check-blue-on'
                            : 'check-blue-off'
                        }.svg`}
                        alt=""
                      />
                      {name}
                    </Option>
                  ))}
                </OptionList>
              );
            })}
          </>
        );
      case '관리지역':
        const allSelectedManagement = ManagementAreaData.every((item) =>
          selectedItems.includes(item.name),
        );
        return (
          <>
            <OptionList>
              <Option
                onClick={() => {
                  if (allSelectedManagement) {
                    setSelectedItems((prev) =>
                      prev.filter(
                        (item) =>
                          !ManagementAreaData.map((d) => d.name).includes(item),
                      ),
                    );
                  } else {
                    setSelectedItems((prev) =>
                      Array.from(
                        new Set([
                          ...prev,
                          ...ManagementAreaData.map((d) => d.name),
                        ]),
                      ),
                    );
                  }
                }}
              >
                <img
                  src={`/assets/images/check/${
                    allSelectedManagement ? 'check-blue-on' : 'check-blue-off'
                  }.svg`}
                  alt=""
                />
                관리지역 전체
              </Option>

              {ManagementAreaData.map(({ name }) => (
                <Option key={name} onClick={() => toggleItem(name)}>
                  <img
                    src={`/assets/images/check/${
                      selectedItems.includes(name)
                        ? 'check-blue-on'
                        : 'check-blue-off'
                    }.svg`}
                    alt=""
                  />
                  {name}
                </Option>
              ))}
            </OptionList>
          </>
        );
      case '기타지역':
        const allSelectedExtraction = ExtractionAreaData.every((item) =>
          selectedItems.includes(item.name),
        );
        return (
          <>
            <OptionList>
              <Option
                onClick={() => {
                  if (allSelectedExtraction) {
                    setSelectedItems((prev) =>
                      prev.filter(
                        (item) =>
                          !ExtractionAreaData.map((d) => d.name).includes(item),
                      ),
                    );
                  } else {
                    setSelectedItems((prev) =>
                      Array.from(
                        new Set([
                          ...prev,
                          ...ExtractionAreaData.map((d) => d.name),
                        ]),
                      ),
                    );
                  }
                }}
              >
                <img
                  src={`/assets/images/check/${
                    allSelectedExtraction ? 'check-blue-on' : 'check-blue-off'
                  }.svg`}
                  alt=""
                />
                기타지역 전체
              </Option>

              {ExtractionAreaData.map(({ name }) => (
                <Option key={name} onClick={() => toggleItem(name)}>
                  <img
                    src={`/assets/images/check/${
                      selectedItems.includes(name)
                        ? 'check-blue-on'
                        : 'check-blue-off'
                    }.svg`}
                    alt=""
                  />
                  {name}
                </Option>
              ))}
            </OptionList>
          </>
        );
      case '용도지구':
        const allSelectedDistrict = UseDistrictData.every((item) =>
          selectedItems.includes(item.name),
        );
        return (
          <>
            <OptionList>
              <Option
                onClick={() => {
                  if (allSelectedDistrict) {
                    setSelectedItems((prev) =>
                      prev.filter(
                        (item) =>
                          !UseDistrictData.map((d) => d.name).includes(item),
                      ),
                    );
                  } else {
                    setSelectedItems((prev) =>
                      Array.from(
                        new Set([
                          ...prev,
                          ...UseDistrictData.map((d) => d.name),
                        ]),
                      ),
                    );
                  }
                }}
              >
                <img
                  src={`/assets/images/check/${
                    allSelectedDistrict ? 'check-blue-on' : 'check-blue-off'
                  }.svg`}
                  alt=""
                />
                용도지구 전체
              </Option>

              {UseDistrictData.map(({ name }) => (
                <Option key={name} onClick={() => toggleItem(name)}>
                  <img
                    src={`/assets/images/check/${
                      selectedItems.includes(name)
                        ? 'check-blue-on'
                        : 'check-blue-off'
                    }.svg`}
                    alt=""
                  />
                  {name}
                </Option>
              ))}
            </OptionList>
          </>
        );
      case '용도구역':
        const allSelectedArea = UseAreaData.every((item) =>
          selectedItems.includes(item.name),
        );
        return (
          <>
            <OptionList>
              <Option
                onClick={() => {
                  if (allSelectedArea) {
                    setSelectedItems((prev) =>
                      prev.filter(
                        (item) =>
                          !UseAreaData.map((d) => d.name).includes(item),
                      ),
                    );
                  } else {
                    setSelectedItems((prev) =>
                      Array.from(
                        new Set([...prev, ...UseAreaData.map((d) => d.name)]),
                      ),
                    );
                  }
                }}
              >
                <img
                  src={`/assets/images/check/${
                    allSelectedArea ? 'check-blue-on' : 'check-blue-off'
                  }.svg`}
                  alt=""
                />
                용도구역 전체
              </Option>

              {UseAreaData.map(({ name }) => (
                <Option key={name} onClick={() => toggleItem(name)}>
                  <img
                    src={`/assets/images/check/${
                      selectedItems.includes(name)
                        ? 'check-blue-on'
                        : 'check-blue-off'
                    }.svg`}
                    alt=""
                  />
                  {name}
                </Option>
              ))}
            </OptionList>
          </>
        );
    }
  };

  const handleReset = () => {
    setSelectedItems([]);
  };

  const handleSubmit = () => {
    setFilters({
      ...filters,
      useArea: selectedItems,
    });
    onClose();
  };

  return (
    <Container>
      <Header>
        <Title>
          <img
            src="/assets/images/arrow/back-arrow-left-gray.svg"
            alt=""
            onClick={() => navigate(-1)}
            width={24}
            height={24}
          />
          용도지역
        </Title>
        <img
          src="/assets/images/close/close-dark-gray.svg"
          alt=""
          onClick={onClose}
        />
      </Header>
      <TabList>
        {TabData.map((data) => (
          <Tab
            active={selectedTab === data}
            onClick={() => setSelectedTab(data)}
          >
            {data}
          </Tab>
        ))}
      </TabList>
      <OptionWrapper>{renderOptionList()}</OptionWrapper>
      <Bottom>
        <SelectedChipBox>
          {selectedItems.map((item) => (
            <SelectedChip>
              {item}
              <img
                src="/assets/images/close/close-gray.svg"
                alt=""
                onClick={() => toggleItem(item)}
              />
            </SelectedChip>
          ))}
        </SelectedChipBox>
        <ButtonBox>
          <ResetButton onClick={handleReset}>
            <img
              src="/assets/images/icon/reset.svg"
              alt=""
              width={24}
              height={24}
            />
            <span>초기화</span>
          </ResetButton>
          <ApplyButton onClick={handleSubmit}>적용</ApplyButton>
        </ButtonBox>
      </Bottom>
    </Container>
  );
}

export default UseAreaOption;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #e1e2e4;
  padding: 12px 16px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const TabList = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow-x: auto;
  border-bottom: 1px solid #e1e2e4;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Tab = styled.div<{ active?: boolean }>`
  flex: 1;
  padding: 14px 16px;
  font-weight: ${(props) => (props.active ? 700 : 500)};
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  white-space: nowrap;

  color: ${(props) => (props.active ? '#000' : '#989BA2')};
  border-bottom: 2px solid ${(props) => (props.active ? '#000' : 'transparent')};
  cursor: pointer;
`;

const OptionWrapper = styled.div`
  flex: 1;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  gap: 8px;
  padding: 24px 16px;
`;

const OptionList = styled.div`
  display: flex;
  flex-direction: column;
`;

const OptionTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const Option = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding: 8px 0;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;
